








































































import Vue from "vue";
export default Vue.extend({
  props: {
    value: {
      type: String,
    },
    off_text: {
      type: String,
      default: "off",
    },
    include: {
      type: Array,
      default: () => ["none", "weekly", "monthly"],
    },
  },
  setup(props, { emit }) {
    const set_value = (val: string) => {
      if (val !== props.value) {
        emit("input", val);
      }
    };
    return {
      set_value,
    };
  },
});
